<section>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
        <br>
        <main class="first-form-margin">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col">
                        <div class="row">
                            <mat-form-field>
                                <input
                                    [attr.data-testid]="'attribute_name_text'"
                                    formControlName="name"
                                    matInput
                                    [pattern]="spaceValidatorPattern"
                                    placeholder="Attribute Name"
                                    required
                                />
                                <mat-error *ngIf="form.controls['name'].invalid">
                                    Please enter a Name
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <input
                                    [attr.data-testid]="'attribute_tag_text'"
                                    formControlName="tag"
                                    matInput
                                    required
                                    placeholder="Attribute Tag"
                                    pattern="^[A-Z_0-9]*$"
                                    (focusout)="findTagExists()"
                                >
                                <mat-error *ngIf="form.controls['tag'].invalid && !form.controls['tag'].value">
                                    Please enter a Standard Tag
                                </mat-error>
                                <mat-error *ngIf="form.controls['tag'].errors?.pattern && form.controls['tag'].value">
                                    Please enter a Valid Standard Tag
                                </mat-error>
                                <mat-error
                                    *ngIf="form.controls['tag'].errors?.tagExists && form.controls['tag'].touched">
                                    Tag already exists! Create a new one.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <input
                                    [attr.data-testid]="'json_attribute_name_text'"
                                    formControlName="objectName"
                                    matInput
                                    placeholder="JSON Attribute Name"
                                    required
                                />
                                <mat-error *ngIf="form.controls['objectName'].invalid">
                                    Please enter a valid JSON Attribute Name
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <mat-select
                                    [attr.data-testid]="'scope_select'"
                                    formControlName="scope"
                                    placeholder="Scope"
                                    required
                                >
                                    <mat-option
                                        *ngFor="let scopeValues of scopes"
                                        [attr.data-testid]="scopeValues.tag + '_option'"
                                        [value]="scopeValues.tag"
                                    >{{ scopeValues.value }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['scope'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row" *ngIf="form.controls['scope'].value === 'GLOBAL'">
                            <mat-form-field>
                                <mat-select
                                    [attr.data-testid]="'item_type_scope_select'"
                                    formControlName="itemTypeScope"
                                    placeholder="Item Type Scope"
                                    required
                                    multiple
                                >
                                    <mat-option
                                        (click)="toggleSelectAll()"
                                        #allSelected
                                        [value]="0"
                                    >
                                        Select All
                                    </mat-option>
                                    <mat-option
                                        *ngFor="let typeValues of itemTypes"
                                        [attr.data-testid]="typeValues.tag + '_option'"
                                        [value]="typeValues.tag"
                                        (click)="toggleSelectOne(allSelected.viewValue)"
                                    >{{ typeValues.value }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['itemTypeScope'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <input
                                    [attr.data-testid]="'sortweight_number'"
                                    formControlName="sortWeight"
                                    matInput
                                    placeholder="SortWeight"
                                    type="number"
                                />
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <mat-select
                                    [attr.data-testid]="'attribute_group_select'"
                                    formControlName="attributeGroup"
                                    placeholder="Attribute Group"
                                    required
                                >
                                    <mat-option
                                        *ngFor="let attributeGroup of attributeGroups"
                                        [attr.data-testid]="attributeGroup.id + '_option'"
                                        [value]="attributeGroup.id"
                                    >{{ attributeGroup.id }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['attributeGroup'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <mat-form-field>
                                <mat-select
                                    [attr.data-testid]="'attribute_type_select'"
                                    formControlName="typetag"
                                    placeholder="Attribute Type"
                                    required
                                >
                                    <mat-option
                                        *ngFor="let attributeTypeValues of attributeTypes"
                                        [attr.data-testid]="attributeTypeValues.name + '_option'"
                                        [value]="attributeTypeValues.tag"
                                    >{{ attributeTypeValues.name }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['typetag'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row" *ngIf="form.controls['typetag'].value === 'SELECT' ||
                        form.controls['typetag'].value === 'MULTI_SELECT'">
                            <mat-form-field>
                                <textarea
                                    #message
                                    [attr.data-testid]="'dropdown_options'"
                                    formControlName="options"
                                    matInput
                                    placeholder="Add option values separated by comma"
                                    [matTooltip]="optionsToolTip"
                                    (focusout)="optionsValidation()"
                                ></textarea>
                                <mat-error *ngIf="form.controls['options'].invalid && !specialCharactersFound">
                                    Add values separated by comma.
                                </mat-error>
                                <mat-error *ngIf="form.controls['options'].invalid && specialCharactersFound">
                                    Special characters are not allowed.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <fieldset *ngIf="form.controls['typetag'].value !== 'SELECT'"
                                      [ngSwitch]="form.controls['typetag'].value">
                                <mat-form-field *ngSwitchCase="'TEXT'">
                                    <input
                                        [attr.data-testid]="'validation_expression'"
                                        formControlName="validationExpression"
                                        matInput
                                        placeholder="Regex validation expression"
                                        type="text"
                                    />
                                </mat-form-field>
                                <mat-form-field *ngSwitchCase="'TEXT'">
                                    <input
                                        [attr.data-testid]="'attribute_type_text'"
                                        formControlName="defaultValue"
                                        matInput
                                        placeholder="Default Value"
                                        type="text"
                                        (focusout)="validationExpressionValidation()"
                                    />
                                </mat-form-field>
                                <mat-form-field *ngSwitchCase="'NUM'">
                                    <input
                                        [attr.data-testid]="'attribute_type_number'"
                                        formControlName="defaultValue"
                                        matInput
                                        placeholder="Default Value"
                                        type="number"
                                        (focusout)="numberValidation()"
                                    />
                                    <mat-error *ngIf="form.controls['defaultValue'].invalid">
                                        Please enter a valid value (e.g. 23.50)
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field *ngSwitchCase="'BOOL'">
                                    <mat-select
                                        [attr.data-testid]="'attribute_type_bool'"
                                        formControlName="defaultValue"
                                        placeholder="Default Value"
                                    >
                                        <mat-option
                                            *ngFor="let requiredTypeValues of defaultRequiredTypes"
                                            [attr.data-testid]="requiredTypeValues.value + '_option'"
                                            [value]="requiredTypeValues.tag"
                                        >{{ requiredTypeValues.value }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field *ngSwitchCase="'DATE'">
                                    <input
                                        [attr.data-testid]="'attribute_type_date'"
                                        formControlName="defaultValue"
                                        [matDatepicker]="picker"
                                        matInput
                                        placeholder="Choose a date"
                                        required="false"
                                    >
                                    <mat-datepicker-toggle
                                        [attr.data-testid]="'attribute_type_date_toggle'"
                                        [for]="picker"
                                        matSuffix
                                    ></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-error *ngIf="form.controls['defaultValue'].invalid">
                                        Please enter a valid date
                                    </mat-error>
                                </mat-form-field>
                                <input
                                    *ngSwitchCase="'DATERANGE'"
                                    [attr.data-testid]="'attribute_type_date_range'"
                                    autoApply="true"
                                    class="form-control"
                                    formControlName="defaultValue"
                                    matInput
                                    ngxDaterangepickerMd
                                    placeholder="Default Value"
                                    showCancel="true"
                                    type="text"
                                    (keyup)="dateRangeUpdated($event)"
                                />
                                <mat-form-field *ngSwitchCase="'IMAGE'">
                                    <input
                                        [attr.data-testid]="'attribute_type_image'"
                                        formControlName="defaultValue"
                                        matInput
                                        placeholder="Default Value"
                                        type="text"
                                        (focusout)="imageValidation()"
                                    />
                                    <mat-error *ngIf="form.controls['defaultValue'].errors?.pattern">
                                        Please enter a valid URL
                                    </mat-error>
                                </mat-form-field>
                            </fieldset>
                        </div>
                        <div class="row" width="6">
                            <mat-form-field>
                                <mat-select
                                    [attr.data-testid]="'required_select'"
                                    formControlName="required"
                                    placeholder="Required"
                                    required
                                >
                                    <mat-option
                                        *ngFor="let requiredTypeValues of requiredTypes"
                                        [attr.data-testid]="requiredTypeValues.tag + '_option'"
                                        [value]="requiredTypeValues.tag"
                                    >{{ requiredTypeValues.value }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['required'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <mat-select
                                    formControlName="localeSupport"
                                    placeholder="Locale Support"
                                    required
                                >
                                    <mat-option [value]="false">Country</mat-option>
                                    <mat-option [value]="true">Locale</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['localeSupport'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                                <mat-select
                                    [attr.data-testid]="'locked_select'"
                                    formControlName="locked"
                                    matTooltip="This will prevent deletion of the attribute"
                                    placeholder="Locked"
                                    required
                                >
                                    <mat-option
                                        *ngFor="let requiredTypeValues of requiredTypes"
                                        [attr.data-testid]="requiredTypeValues.value + '_option'"
                                        [value]="requiredTypeValues.tag"
                                    >{{ requiredTypeValues.value }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.controls['locked'].invalid">
                                    Please Select a Value
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="row">
                            <mat-form-field>
                        <textarea
                            #message
                            [attr.data-testid]="'description_textarea'"
                            formControlName="description"
                            matInput
                            maxlength="256"
                            placeholder="Description"
                        ></textarea>
                                <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <footer>
            <button
                [attr.data-testid]="'cancel_button'"
                mat-raised-button
                matTooltip="Cancel creating Attribute"
                type="button"
                (click)="onNoClick()"
            >
                Cancel
            </button>
            <button
                [attr.data-testid]="'save_button'"
                [disabled]="!form.valid || disableSave"
                mat-raised-button
                matTooltip="Submit Attribute"
                type="submit"
            >
                Save
            </button>
        </footer>
    </form>
</section>
